import React from 'react'
import ServiceSection from '../../Components/mumbai/ServiceSection';
import ServiceNowConsultingSlider from '../../Components/mumbai/ServiceNowConsultingSlider';
import MaximizeModal from '../../Components/mumbai/MaximizeModal';
import IndustriesSliderSection from '../../Components/mumbai/IndustriesSliderSection';
import ServiceNowBannerSection from '../../Components/mumbai/ServiceNowBannerSection';
import { Helmet } from 'react-helmet-async'
import HireDeveloper from '../../Components/hire/HireDeveloper';
import HeroServiceSection from '../../Components/mumbai/HeroServiceSection';
import LocationForm from '../../Components/mumbai/LocationForm';
import WhyChoose from '../../Components/mumbai/WhyChoose';
import EngagementModels from '../../Components/hire/EngagementModels';
import ServiceNowLeadForm from '../../Components/ServiceNowLeadForm';

const wellbeingData = [
    {
        id: 1,
        title: "Comprehensive Support",
        description: "Mobikode’s Sharjah team provides reliable support, smart solutions, and continuous guidance to help your business grow confidently.",
        image: "/assets/mumbai/img2.png"
    },
    {
        id: 2,
        title: "Industry Expertise ",
        description: "Empowering Sharjah businesses with human-focused digital solutions, innovative technology, and seamless experiences that drive growth and lasting success.",
        image: "/assets/mumbai/img2.png"
    },
    {
        id: 3,
        title: "Customized Solutions",
        description: "Mobikode delivers tailored digital solutions in Sharjah, helping businesses streamline processes, achieve goals, and grow smarter.",
        image: "/assets/mumbai/img2.png"
    },

];


const consultingData = [
    {
        id: 1,
        title: "ServiceNow Consulting",
        desc: "Strategic platform advisory, maturity assessments, and digital roadmap formulation tailored to optimize your ServiceNow enterprise landscape.",
        link: "/service/servicenow-consulting",
    },
    {
        id: 2,
        title: "ServiceNow Implementation",
        desc: "End-to-end multi-module deployment, configuration, and workflow automation executed with best practices for swift enterprise adoption.",
        link: "/service/servicenow-implementation",
    },
    {
        id: 3,
        title: "ServiceNow ITSM",
        desc: "Modernize service desk operations, incident triage, change management, and request fulfillment through intelligent IT service management.",
        link: "/service/servicenow-itsm",
    },
    {
        id: 4,
        title: "ServiceNow ITOM & CMDB",
        desc: "Gain real-time infrastructure visibility, build an accurate healthy CMDB, and automate event remediation with predictive discovery.",
        link: "/service/servicenow-itom-cmdb",
    },
    {
        id: 5,
        title: "ServiceNow CSM",
        desc: "Deliver connected customer experiences by breaking down silos across front, middle, and back-office teams with proactive issue resolution.",
        link: "/service/servicenow-csm",
    },
    {
        id: 6,
        title: "ServiceNow HRSD",
        desc: "Elevate employee experiences with streamlined onboarding, unified life-event journeys, and self-service HR service delivery portals.",
        link: "/service/servicenow-hrsd",
    },
    {
        id: 7,
        title: "ServiceNow AI & Automation",
        desc: "Leverage Generative AI, Now Assist, machine learning models, and virtual agents to automate complex multi-departmental workflows.",
        link: "/service/servicenow-ai-automation",
    },
    {
        id: 8,
        title: "ServiceNow Integration",
        desc: "Seamlessly integrate your ServiceNow instance with ERPs, CRMs, cloud platforms, and legacy systems via Integration Hub and custom APIs.",
        link: "/service/servicenow-integration",
    },
    {
        id: 9,
        title: "ServiceNow Custom Development",
        desc: "Build scalable, tailor-made applications and intuitive enterprise service portals using ServiceNow App Engine and UI Builder.",
        link: "/service/servicenow-custom-development",
    },
    {
        id: 10,
        title: "ServiceNow Managed Services",
        desc: "Continuous proactive support, performance monitoring, release upgrades, technical debt reduction, and platform governance.",
        link: "/service/servicenow-managed-services",
    },
    {
        id: 11,
        title: "ServiceNow Resource Augmentation",
        desc: "Scale your delivery bandwidth with certified ServiceNow architects, developers, technical consultants, and flexible dedicated pods.",
        link: "/service/servicenow-resource-augmentation",
    },
    {
        id: 12,
        title: "ServiceNow Center of Excellence (COE)",
        desc: "Build a scalable ServiceNow ecosystem with strong governance, platform standardization, continuous improvement, and enterprise-wide innovation.",
        link: "/service/servicenow-coe",
    },
];

const industriesData = [
    {
        id: 1,
        title: "Financial Services",
        desc: "Helping Sharjah’s financial businesses modernize operations, enhance customer experiences, and achieve sustainable growth with secure, reliable, and innovative digital solutions tailored to their evolving needs.",
        image: "/assets/mumbai/item1.png"
    },
    {
        id: 2,
        title: "eCommerce ",
        desc: "Helping Sharjah’s eCommerce businesses grow with smart digital solutions, seamless experiences, and reliable technology that simplifies operations, strengthens customer connections, and supports long-term business success.",
        image: "/assets/mumbai/item2.png"
    },
    {
        id: 3,
        title: "Insurance ",
        desc: "Helping Sharjah’s insurance companies modernize operations, simplify claims and policy management, enhance customer experiences, and achieve sustainable growth with secure, smart, and reliable digital solutions from Mobikode.",
        image: "/assets/mumbai/item3.png"
    },
    {
        id: 4,
        title: "Manufacturing",
        desc: "Mobikode helps manufacturing businesses in Sharjah adopt smarter digital solutions, streamline operations, enhance productivity, and build efficient processes that drive sustainable growth and business success.",
        image: "/assets/mumbai/item4.png"
    },
    {
        id: 5,
        title: "Retail & Consumer Goods",
        desc: "Mobikode helps Sharjah’s retail and consumer brands thrive with smart digital solutions that enhance customer experiences, streamline operations, and enable sustainable business growth.",
        image: "/assets/mumbai/item5.png"
    },
    {
        id: 6,
        title: "Healthcare & Life Sciences",
        desc: "At Mobikode, we empower Healthcare & Life Sciences organizations in Sharjah with smart digital solutions that enhance patient experiences, streamline operations, and support better healthcare outcomes.",
        image: "/assets/mumbai/item6.png"
    },
    {
        id: 7,
        title: "Media & Communications ",
        desc: "Mobikode empowers Sharjah’s media and communication businesses with innovative digital solutions that enhance audience engagement, simplify operations, and create impactful brand experiences through technology and creativity.",
        image: "/assets/mumbai/item7.png"
    },
    {
        id: 8,
        title: "Logistics & Transportation ",
        desc: "Mobikode helps Sharjah’s logistics and transportation businesses streamline operations, enhance delivery experiences, and achieve sustainable growth with smart, reliable digital solutions built around their unique needs.",
        image: "/assets/mumbai/item8.png"
    },
    {
        id: 9,
        title: "Technology",
        desc: "Mobikode partners with technology companies in Sharjah to transform ideas into smart digital solutions, combining innovation, expertise, and human-focused technology to drive sustainable business growth.",
        image: "/assets/mumbai/item9.png"
    },
    {
        id: 10,
        title: "Non Profit",
        desc: "Mobikode empowers non-profit organizations in Sharjah with smart digital solutions that simplify operations, strengthen outreach, and help them create meaningful, lasting impact in communities.",
        image: "/assets/mumbai/item10.png"
    },
    {
        id: 11,
        title: "Professional Services ",
        desc: "At Mobikode, we help Sharjah’s professional service businesses streamline operations, adopt smart digital solutions, and deliver seamless client experiences with reliable, customized technology designed for growth.",
        image: "/assets/mumbai/item11.png"
    },
    {
        id: 12,
        title: "Real Estate ",
        desc: "At Mobikode, we help Sharjah’s real estate businesses thrive with smart digital solutions that streamline operations, enhance customer experiences, and build meaningful connections between developers, agents, and buyers.",
        image: "/assets/mumbai/item12.png"
    },

];

function Sharjah() {
    return (
        <div>
            <Helmet>
                <title>
                    ServiceNow Consulting in Sharjah | ITSM & Process Automation | Mobikode
                </title>

                <meta
                    name="description"
                    content="Mobikode provides ServiceNow consulting in Sharjah to optimize IT service management, automate business processes, improve service delivery, and create more efficient digital operations."
                />

                <meta
                    name="keywords"
                    content="ServiceNow Consulting Sharjah, ServiceNow Consultant Sharjah, ServiceNow ITSM Sharjah, ServiceNow Process Automation Sharjah, ServiceNow Service Management Sharjah, ServiceNow Implementation Sharjah, ServiceNow Integration Sharjah, ServiceNow Workflow Automation Sharjah, ServiceNow Managed Services Sharjah, ServiceNow Solutions Sharjah"
                />

                <link
                    rel="canonical"
                    href="https://www.mobikode.com/location/leverage-serviceNow-consulting-in-sharjah"
                />

                <meta
                    property="og:title"
                    content="ServiceNow Consulting in Sharjah | ITSM & Process Automation | Mobikode"
                />

                <meta
                    property="og:description"
                    content="Enhance service delivery with Mobikode's ServiceNow consulting in Sharjah. We help businesses optimize ITSM, automate processes, improve workflows, and build efficient digital operations."
                />

                <meta
                    property="og:url"
                    content="https://www.mobikode.com/location/leverage-serviceNow-consulting-in-sharjah"
                />

                <meta
                    property="og:type"
                    content="website"
                />

                <meta
                    property="og:image"
                    content="https://www.mobikode.com/assets/sharjah/bg1.png"
                />

                <meta
                    name="twitter:card"
                    content="summary_large_image"
                />

                <meta
                    name="twitter:title"
                    content="ServiceNow Consulting in Sharjah | Mobikode"
                />

                <meta
                    name="twitter:description"
                    content="Discover ServiceNow consulting solutions in Sharjah for ITSM, process automation, workflow improvement, service delivery, and digital operations with Mobikode."
                />

                <meta
                    name="twitter:image"
                    content="https://www.mobikode.com/assets/sharjah/bg1.png"
                />
            </Helmet>
            <HeroServiceSection bgImage="/assets/mumbai/bg1.png" title="Leverage ServiceNow Consulting in Sharjah" description="Partner with Mobikode’s ServiceNow experts in Sharjah to simplify daily operations, empower your teams, automate business processes, and achieve sustainable growth through intelligent digital transformation. Trusted by Startups and Leading Companies Worldwide" />
            <ServiceNowLeadForm bgImage="/assets/mumbai/Sharjah.png" />
            <ServiceNowConsultingSlider consultingData={consultingData} />
            <WhyChoose />
            <MaximizeModal wellbeingData={wellbeingData} />
            <EngagementModels />
            <IndustriesSliderSection industriesData={industriesData} />

            {/* <section className="relative w-full h-[500px] lg:h-[630px] flex items-center bg-[#000814] overflow-hidden py-12 md:py-0">
                <div className="absolute inset-0 z-0">
                    <img
                        src="/assets/mumbai/bg1.png"
                        alt="Abstract 3D Background"
                        className="w-full h-full object-cover"
                    />
                    <div
                        style={{ background: "linear-gradient(86.84deg, #000000 20%, rgba(0, 0, 0, 0) 79%)" }}
                        className="hidden md:block absolute inset-0"
                    ></div>
                    <div
                        style={{ background: "linear-gradient(0deg, #000000 40%, rgba(0, 0, 0, 0.3) 100%)" }}
                        className="block md:hidden absolute inset-0"
                    ></div>
                </div>

                <div className="relative z-10 w-full max-w-[1440px] mx-auto px-[20px] md:px-[40px] lg:px-[80px] flex flex-col items-start justify-center h-full">
                    <div className="w-full max-w-[500px] md:max-w-[700px] lg:max-w-[900px] mt-auto md:mt-0">
                        <h1 className="text-white font-[600] text-[28px] sm:text-[36px] md:text-[50px] lg:text-[60px] font-sora leading-[1.2] lg:leading-[1.1] mb-[12px] lg:mb-[22px] drop-shadow-xl tracking-wide text-left">
                            Leverage ServiceNow Consulting in Sharjah
                        </h1>
                        <p className="text-[#FFFFFF] max-w-[800px] w-full text-[14px] sm:text-[16px] md:text-[18px] leading-[20px] md:leading-[22px] lg:leading-[24px] font-graphik font-light tracking-wider text-left opacity-90 lg:opacity-100">
                            Mobikode helps Sharjah businesses streamline operations, automate workflows, boost productivity, and achieve sustainable growth with expert ServiceNow solutions.
                        </p>
                    </div>
                </div>
            </section> */}
            {/* <ServiceSection image={"/assets/mumbai/Sharjah.png"}
                text={"At Mobikode, we help businesses in Sharjah unlock the full potential of ServiceNow with smart, practical, and customized solutions. Our experts simplify workflows through seamless implementation, automation, integrations, and ongoing support. We empower organizations to improve efficiency, enhance employee experiences, and build scalable digital solutions that drive sustainable growth and transformation."}
                title={"ServiceNow Consulting"} />
            <ServiceNowConsultingSlider consultingData={consultingData} />
            <MaximizeModal wellbeingData={wellbeingData} />
            <IndustriesSliderSection industriesData={industriesData} />
            <ServiceNowBannerSection imgs={"/assets/mumbai/img3.png"}
                title="ServiceNow Consulting Services"
                text="At Mobikode, we help Sharjah businesses unlock ServiceNow’s potential with personalized consulting, intelligent automation, and seamless digital solutions that simplify operations, enhance productivity, and drive growth." />
            <HireDeveloper /> */}
        </div>
    )
}

export default Sharjah
